class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    if (typeof KlaviyoSubscribe === "undefined") return;

    this.preference = null;
    this.preferenceInputs = this.querySelectorAll("[data-preference-selector]");

    this.initFunction();
  }

  initFunction() {
    this.initKlaviyoForm();
    this.form.email.addEventListener("keypress", this.removeError.bind(this));
    this.form.addEventListener("submit", this.handleErrorValidation.bind(this));

    this.preferenceInputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        this.preference = event.target.value;

        KlaviyoSubscribe.attachToForms(this.form, {
          hide_form_on_success: true,
          success: () => {
            this.classList.add("success");

            setTimeout(() => {
              this.classList.remove("success");
            }, 5000);
          },
          extra_properties: {
            $source: "Shopify Form",
            $method_type: "Custom Klaviyo Form",
            $consent_version: "",
          },
        });
      });
    });
  }

  initKlaviyoForm() {
    KlaviyoSubscribe.attachToForms(this.form, {
      hide_form_on_success: true,
      success: () => {
        this.classList.add("success");

        setTimeout(() => {
          this.classList.remove("success");
        }, 5000);
      },
      extra_properties: {
        $source: "Shopify Form",
        $method_type: "Custom Klaviyo Form",
        $consent_version: "",
      },
    });
  }

  handleErrorValidation(event) {
    const email = this.form.email.value;
    const emailInput = this.form.email;
    const emailError = this.form.querySelector(".input-label__error");
    if (this.validateEmail(email)) {
      emailInput.classList.remove("error");
    } else {
      event.preventDefault();
      if (emailError.querySelector(".message")) {
        emailError.querySelector(".message").remove();
      }

      const errorMessage =
        this.form.email.dataset.errorMessage ||
        "Please enter a valid email address";

      emailError.innerHTML = errorMessage;
      emailInput.classList.add("error");
      emailInput.value = "";
      document.activeElement.blur();
    }
  }

  removeError() {
    this.form.email.classList.remove("error");
  }

  validateEmail(email) {
    if (new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}").test(email)) {
      return true;
    }

    return false;
  }
}

if (!customElements.get("klaviyo-form")) {
  customElements.define("klaviyo-form", KlaviyoForm);
}
